import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const checkEmailExistsAndRole = async (forgotEmail) => {
  const response = await axios.post(`${apiUrl}/api/forgotusercheck/`, {
    email: forgotEmail,
  });
  return response;
};

export const generateOtpWithAction = async (forgotEmail, otpAction) => {
  const response = await axios.post(`${apiUrl}/api/generate-otp/`, {
    email: forgotEmail,
    action: otpAction,
  });
  return response;
};

export const verifyOtp = async (email, action, otp) => {
  const response = await axios.post(`${apiUrl}/api/verify-otp/`, {
    email: email,
    action: action,
    otp: otp,
  });

  return response;
};

export const resetPwd = async (forgotEmail, mynewPwd) => {
  const response = await axios.post(`${apiUrl}/api/reset-password/`, {
    email: forgotEmail,
    new_password: mynewPwd,
  });
  return response;
};

export const updPwdReq = async (forgotEmail, myrole) => {
  if (myrole === "companyuser") {
    const response = await axios.post(
      `${apiUrl}/api/update-passwordreq_user/`,
      {
        email: forgotEmail,
        type: "user",
      },
    );
    return response;
  } else if (myrole === "customer") {
    const response = await axios.post(`${apiUrl}/api/update-passwordreq/`, {
      email: forgotEmail,
      type: myrole,
    });
    return response;
  } else {
    // console.log("role is not proper");
  }
};
